import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default createStore({
  state: {
    api_url: null,
    request_context: null,
    
  },
  mutations: {

    setApiUrl: function( state, api_url ){
      state.api_url = api_url;
    },

    setRequestContext: function( state, request_context ){
      state.request_context = request_context;
    },


  },
  
 
  plugins: [vuexLocal.plugin]
})
